import { useEffect, useState } from "react";
import { KeyConstant } from "const";
import { BranchUtils, StorageUtils } from "utils";

const Monitoring = () => {
  const currentBranchId = StorageUtils.getStoreData(KeyConstant.KEY_BRANCH_ID);

  const [monitorUrl, setMonitorUrl] = useState(null);

  useEffect(() => {
    const currentBranch = BranchUtils.getCurrentBranch();
    setMonitorUrl(currentBranch.options?.monitoring_url);
  }, [currentBranchId]);

  return (
    Boolean(monitorUrl) && (
      <iframe
        title="Monitoring"
        src={monitorUrl}
        style={{ width: "100%", height: "calc(100vh - 80px)", border: "none", minHeight: "600px" }}
      />
    )
  );
};

export default Monitoring;
